// Libs
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

// RDS
import FormField from '@ramsey-design-system/form-field';
import Heading from '@ramsey-design-system/heading';
import Input from '@ramsey-design-system/input';

// Components
import WorkshopStepNavigation from '../WorkshopStepNavigation';

// Hooks
import { useWorkshopStepContext } from '../WorkshopStepContext';

// Types
import { WorkshopFormValues } from '../types';

function WorkshopDetails() {
  const {
    control,
    register,
    setFocus,
    formState: { errors }
  } = useFormContext<WorkshopFormValues>();

  const { focusField, setFocusField } = useWorkshopStepContext();

  const name = useWatch({ control, name: 'name' });

  useEffect(() => {
    if (focusField) {
      setFocus(focusField);
      setFocusField(null);
    }
  }, [focusField, setFocus, setFocusField]);

  return (
    <section>
      <Heading level="2" className="text-6 mb-3">
        Workshop Details
      </Heading>

      <FormField
        className="mb-3"
        label="Workshop Name"
        invalid={Boolean(errors.name)}
        errors={[errors.name?.message]}
      >
        {(props) => (
          <Input
            {...props}
            {...register('name', {
              required: 'Workshop name is required.'
            })}
            data-testid="workshop-name-input"
            className="w-full"
          />
        )}
      </FormField>

      <FormField className="mb-3" label="Location" note="(optional)">
        {(props) => (
          <Input
            {...props}
            {...register('location')}
            data-testid="workshop-location-input"
            placeholder="e.g. Room 204, Main Campus"
            className="w-full"
          />
        )}
      </FormField>

      <WorkshopStepNavigation disableNextStep={!name?.trim()} />
    </section>
  );
}

export default WorkshopDetails;
